module.exports = "/_next/static/images/kobikicho_soba-0d95bf68829b8095e5e48d2f0ed46711.jpg";